import * as Yup from 'yup';

export const seasonChallengeSchema = Yup.object({
  title: Yup.string().required('El título es requerido'),
  description: Yup.string().optional(),
  dayNumber: Yup.number()
    .required('El número de día es requerido')
    .min(1, 'El número de día debe ser mayor a 0'),
  clawCoinsReward: Yup.number().min(1, 'La recompensa de Claw Coins debe ser mayor a 0').required('La recompensa de Claw Coins es requerida'),
  gameSeasonId: Yup.number().required('La temporada es requerida'),
  extra_data: Yup.object().optional()
});

export type SeasonChallengeFormData = {
  title: string;
  description?: string;
  dayNumber: number;
  clawCoinsReward: number;
  gameSeasonId: number;
  extra_data?: {
    [key: string]: any;
  };
};
